import { render, staticRenderFns } from "./IssueActionsTableCell.vue?vue&type=template&id=68aee2c6&scoped=true"
import script from "./IssueActionsTableCell.vue?vue&type=script&lang=js"
export * from "./IssueActionsTableCell.vue?vue&type=script&lang=js"
import style0 from "./IssueActionsTableCell.vue?vue&type=style&index=0&id=68aee2c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68aee2c6",
  null
  
)

export default component.exports